import * as React from 'react';
import { Reservable } from '../../../../commonv3/types/reservable';
import moment from 'moment-timezone';
import './reservableSummary.module.scss';
import { BodyText, Heading } from '@sheinc/shelikes-design-system';

type Props = {
  title: string;
  reservable: Reservable;
};

export class ReservableSummary extends React.Component<Props> {
  render() {
    const { title, reservable } = this.props;
    const { starts_at, ends_at, location, capacity, active_reservation_count } = reservable;
    return (
      <div styleName="reservable-summary">
        <div styleName="header">
          <Heading size="S">{title}</Heading>
          <div styleName="time-range">
            <BodyText>
              {moment(starts_at).format('M月D日')} {moment(starts_at).format('HH:mm')} -{' '}
              {moment(ends_at).format('HH:mm')}
            </BodyText>
          </div>
        </div>
        <div styleName="footer">
          <BodyText>場所: {location ? location.name : 'オンライン'}</BodyText>
          <BodyText>
            申込者: {active_reservation_count}/{capacity}人
          </BodyText>
        </div>
      </div>
    );
  }
}
